import React from "react";
import { XIcon } from "staysure-component-library";

import LabelButtonWrapper, {
  IconButtonWrapper,
} from "@/components/atoms/button-wrapper/button-wrapper";
import selectedColorBrand from "@/config/tailwind-colors/brand-colors";

type RemoveModalProps = {
  onSelect?: (e: boolean) => void;
  title: string;
  description: string;
  confirmCTALabel: string;
  cancelCTALabel: string;
};

function RemoveModal({
  onSelect,
  title,
  description,
  confirmCTALabel,
  cancelCTALabel,
}: Readonly<RemoveModalProps>) {
  return (
    <div
      data-testid="remove-modal-testid"
      className="md:p-spacing-xxxl p-spacing-l"
    >
      <div className="md:w-spacing-xxxl md:h-spacing-xxxl w-spacing-xxl h-spacing-xxl absolute m-[2px] right-0 top-0 flex items-center justify-center">
        <IconButtonWrapper
          data-testid="remove-modal-close-button"
          id="remove-modal-close-button"
          hierarchy="tertiary"
          btnType="icon"
          icon={
            <XIcon
              stroke={selectedColorBrand["interactive-secondary-default"]}
            />
          }
          className="w-[24px] h-[24px] text-[24px] text-text-on-primary "
          onClick={() => {
            if (onSelect !== undefined) {
              onSelect(true);
            }
          }}
        />
      </div>
      <div>
        <h1 className="text-text-title md:mb-spacing-s mb-spacing-xs text-[23px] md:text-[31px] font-header-font font-[400] md:leading-[110%] leading-[120%]">
          {title}
        </h1>
      </div>
      <div className="mb-spacing-l">
        <p className="text-text-body text-[18px] font-body-font font-[400] leading-[150%] ">
          {description}
        </p>
      </div>
      <div className="md:flex md:justify-between">
        <LabelButtonWrapper
          data-testid="remove-modal-confirm-button"
          id="remove-modal-confirm-button"
          hierarchy="primary"
          label={confirmCTALabel}
          className="md:!w-[148px] w-full mr-[0px] mb-[8px] md:mb-[0px] text-[18px] font-body-font h-[48px] max-h-[48px] font-[600] leading-[100%] text-text-on-primary !rounded-radius-full"
          onClick={() => {
            if (onSelect !== undefined) {
              onSelect(false);
            }
          }}
        />

        <LabelButtonWrapper
          data-testid="remove-modal-cancel-button"
          id="remove-modal-cancel-button"
          hierarchy="secondary"
          label={cancelCTALabel}
          className="md:w-[148px] w-full text-[18px] font-body-font h-[48px] max-h-[48px] font-[600] leading-[100%] text-interactive-secondary-default !rounded-radius-full"
          onClick={() => {
            if (onSelect !== undefined) {
              onSelect(true);
            }
          }}
        />
      </div>
    </div>
  );
}

export default RemoveModal;
